module.exports = __webpack_public_path__ + "media/clap.a6e86dd7.wav";